module.exports = __webpack_public_path__ + "img/empty.dab21f58.png";